import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { GridColumns } from '@mui/x-data-grid-pro';
import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';

export const useGetColumns = () => {
  const { t } = useTranslation();

  return useMemo<GridColumns>(
    () => [
      {
        headerName: t('dtrRules.column.enabled'),
        field: 'enabled',
        type: 'boolean',
        width: 80,
        renderCell: ({ value }) => <BooleanCell value={value} />
      },
      {
        headerName: t('dtrRules.column.name'),
        field: 'name',
        type: 'string',
        hideable: false,
        valueGetter: (params) => t(`dtrRules.rule.${params.value}`),
        flex: 1
      }
    ],
    []
  );
};
